import React, { useEffect, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import PoweredByBox from '../common/poweredByBox';
import { TransactionStatus } from '../common/constants';

const assignNestedValue = (target, fullKey, value) => {
    if (!fullKey) {
        return;
    }

    const keys = fullKey.split('.');
    let current = target;

    for (let index = 0; index < keys.length; index++) {
        const key = keys[index];

        if (index === keys.length - 1) {
            current[key] = value;
            return;
        }

        const next = current[key];
        if (typeof next !== 'object' || next === null) {
            current[key] = {};
        }

        current = current[key];
    }
};

const constructPostMessage = (redirectPayload) => {
    return {
        status: redirectPayload.success ? TransactionStatus.Successful : TransactionStatus.Failed,
        order_id: redirectPayload.merchant_order_id,
        error_code: redirectPayload.acq_response_code,
        error_message: redirectPayload.data.message,
        amount: (redirectPayload.amount_cents / 100).toFixed(2),
        currency: redirectPayload.currency,
    };
}

const parseRedirectPayload = () => {
    const params = new URLSearchParams(window.location.search);
    const payload = {};

    params.forEach((value, key) => {
        let parsedValue = value;
        try {
            parsedValue = JSON.parse(value);
        } catch (error) {
            parsedValue = value;
        }

        assignNestedValue(payload, key, parsedValue);
    });

    return payload;
};

const PaymobTransactionCallback = () => {
    const redirectPayload = useMemo(parseRedirectPayload, []);
    const postMessage = constructPostMessage(redirectPayload);

    const isSuccessful = postMessage.status === TransactionStatus.Successful;
    const titleClass = isSuccessful ? 'text-success' : 'text-danger';
    const titleText = isSuccessful ? 'Payment completed successfully!' : 'Payment failed!';

    useEffect(() => {
        window.parent.postMessage(postMessage, '*');
    }, [postMessage]);

    return (
        <Container style={{ marginTop: "50px" }}>
            <div className="row p-4">
                <div className='col-lg-3'></div>
                <div className='col-lg-6 p-4 main-box'>
                    <div>
                        <h3 className={`text-center mt-4 ${titleClass}`}>
                            {titleText}
                        </h3>
                        {
                            postMessage.amount
                                ? <p className='text-center mt-3'>Amount: {postMessage.amount} {postMessage.currency}</p>
                                : null
                        }
                        <br />
                        <PoweredByBox />
                        <br />
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default PaymobTransactionCallback;
